<app-dialog-header titleTranslateKey="scheduler.setup.zone.delete.title" (closeClicked)="cancel()">
</app-dialog-header>

<mat-dialog-content class="fullscreen-dialog">
  <p>If this zone has been used for any jobs, deletion will fail.</p>
  <p>Are you sure you wish to delete this zone?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button (click)="cancel()" color="accent" mat-raised-button>Cancel Deletion</button>
  <button (click)="confirm()" color="warn" mat-raised-button>Confirm Deletion</button>
</mat-dialog-actions>